import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonModal,
  IonToolbar,
} from '@ionic/react';
import { IS_INSTAGRAM } from '../../utils/browser';
import { Welcome } from './Welcome';
import { AnalyticEventsEnum, trackEvent } from '../../Analytics';
import { arrowBack, closeOutline } from 'ionicons/icons';

import s from '../ContactInfoModal/ContactInfoModal.module.scss';
import { Options } from './Options';
import { ActiveCountriesEnum } from '../Location/config';

export const LocationUnavailableModal = ({
  close,
  isOpen,
}: {
  close: () => void;
  isOpen: boolean;
}) => {
  const [selectedCountry, setSelectedCountry] = useState<ActiveCountriesEnum>();

  const modalRef = useRef<HTMLIonModalElement>(null);

  const submitModal = () => {
    modalRef.current?.dismiss(undefined, 'submit');
  };

  useEffect(() => {
    setSelectedCountry(undefined);
  }, [isOpen]);

  return (
    <IonModal
      isOpen={isOpen}
      ref={modalRef}
      // animated={!IS_INSTAGRAM}
      backdropDismiss={false}
      handle={false}
      onWillDismiss={event => {
        close();
        if (event.detail.role !== 'submit') {
          trackEvent(AnalyticEventsEnum.MODAL_CLOSED);
        }
      }}
      className={clsx(s.IonModal)}
    >
      <IonHeader>
        <IonToolbar mode="ios">
          {selectedCountry && (
            <IonButtons slot="start">
              <IonButton onClick={() => setSelectedCountry(undefined)}>
                <IonIcon icon={arrowBack} className={clsx(s.Back__button)} />
              </IonButton>
            </IonButtons>
          )}

          <IonButtons slot="end">
            <IonButton
              onClick={() => modalRef.current?.dismiss(undefined, 'close')}
            >
              <IonIcon icon={closeOutline} className={clsx(s.Close__button)} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      {!selectedCountry ? (
        <Welcome
          submitModal={submitModal}
          setSelectedCountry={setSelectedCountry}
        />
      ) : (
        <Options country={selectedCountry} submitModal={submitModal} />
      )}
    </IonModal>
  );
};
